module.exports = __webpack_public_path__ + "img/business_06.d8fa03cc.jpg";